import clsx from 'clsx'
import { InputHTMLAttributes } from 'react'
import { FieldValues, Path, UseFormRegister } from 'react-hook-form'

export interface FormInputProps<T extends FieldValues>
  extends Omit<InputHTMLAttributes<HTMLInputElement>, 'name'> {
  label?: string
  labelPosition?: 'start' | 'end'
  error?: string
  register?: UseFormRegister<T>
  name: Path<T>
  validation?: object
  color?: string
}

export function FormInput<T extends FieldValues>({
  label,
  error,
  labelPosition = 'start',
  register,
  name,
  validation,
  className,
  color = '#F07F64',
  ...props
}: FormInputProps<T>) {
  return (
    <div className={clsx('flex flex-col gap-2', className)}>
      {label && labelPosition === 'start' && (
        <label
          htmlFor={props.id}
          className="block text-md font-medium text-white"
        >
          {label}
        </label>
      )}
      <input
        {...register?.(name, validation)}
        style={
          {
            '--accent-color': color,
          } as React.CSSProperties
        }
        className={clsx({
          'w-full px-3 py-2 tc-mv-question-field text-white rounded-2xl outline-none disabled:opacity-70':
            props.type === 'text' || props.type === 'url',
          'border-red-500': error,
          'appearance-none w-5 h-5 bg-white rounded-full border-2 border-gray-400 checked:border-[var(--accent-color)] checked:before:block checked:before:content-[""] checked:before:relative checked:before:top-[2px] checked:before:left-[2px] checked:before:w-3 checked:before:h-3 checked:before:rounded-full checked:before:bg-[var(--accent-color)] checked:before:transform':
            props.type === 'radio',
          'appearance-none w-4 h-4 bg-white rounded border-2 border-gray-400 checked:border-[var(--accent-color)] relative checked:after:content-[""] checked:after:w-2 checked:after:h-2 checked:after:rounded-sm checked:after:absolute checked:after:bg-[var(--accent-color)] checked:after:left-[2px] checked:after:top-[2px]':
            props.type === 'checkbox',
        })}
        {...props}
      />
      {label && labelPosition === 'end' && (
        <label
          htmlFor={props.id}
          className="block text-md font-medium text-white"
        >
          {label}
        </label>
      )}
      {error && <span className="text-red-500 text-sm pl-2">{error}</span>}
    </div>
  )
}
